import store from '@store';
import { createAction, createSuccessActionType } from '@store/utils';

export const getMyRestaurant = createAction('restaurant/GET_MY_RESTAURANT');
export const getMyRestaurantSuccess = createAction(createSuccessActionType(getMyRestaurant.type));
export const getDetailRestaurant = createAction('restaurant/GET_DETAIL_RESTAURANT');
export const setSelectionFood = createAction('food/SET_FOODS');
export const getDetailRestaurantSuccess = createAction(createSuccessActionType(getDetailRestaurant.type));
export const clearRestaurant = createAction('restaurant/CLEAR_RESTAURANT');
export const actions = {
    getMyRestaurant,
    getMyRestaurantSuccess,
    getDetailRestaurant,
    getDetailRestaurantSuccess,
    clearRestaurant,
    getCurrencyData: () => {
        const state = store.getState();
        const currency = state.restaurant.detailRestaurant;
        return currency || {};
    },
};
